import { unescape } from 'lodash';
var COMPLEX_DESCRIPTION_TAGS = ['audio', 'blockquote', 'canvas', 'embed', 'figure', 'fib-blank', 'iframe', 'img', 'object', 'ol', 'pre', 'svg', 'table', 'ul', 'video'];
var COMPLEX_DESCRIPTION_TAG_PATTERN = new RegExp("<(?:".concat(COMPLEX_DESCRIPTION_TAGS.join('|'), ")(?=[\\s/>])"), 'i');
var COMPLEX_DESCRIPTION_SELECTOR = COMPLEX_DESCRIPTION_TAGS.join(',');
/** Rich block content stays fully visible so media and interactive structures are never clipped. */

export var hasComplexDescriptionContent = function hasComplexDescriptionContent(description) {
  return Boolean(description && COMPLEX_DESCRIPTION_TAG_PATTERN.test(unescape(description)));
};
export var hasComplexRenderedDescriptionContent = function hasComplexRenderedDescriptionContent(element) {
  return Boolean(element === null || element === void 0 ? void 0 : element.querySelector(COMPLEX_DESCRIPTION_SELECTOR));
};